export default __webpack_public_path__ + "static/media/maptip.3692354e.png";